import { Routes, Route } from 'react-router'
import DiscoverCat from './pages/discover-cat/DiscoverCat'

function App() {
  return (
    <Routes>
      <Route
        path='/'
        element={<DiscoverCat />}
      />
    </Routes>
  )
}

export default App
